"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LeitungCalculator = void 0;
const echain_shared_quantities_1 = require("@igus/echain-shared-quantities");
class LeitungCalculator {
    /**
     * Calculates the leitungslaenge in relation to the RCB configuration with given cable overlaps.
     *
     * Base calculation is: Leitugnslaenge = eff. Kettenlaenge + AEMitnehmer + AEFestpunkt +
     * UeberstandFestpunkt + UeberstandMitnehmer
     *
     * @param effektiveKetteWithAEs The actual length of the chain + connectors
     * @param ueberstand1 First overlap
     * @param ueberstand2 Second overlap
     * @returns
     */
    static calcLeitungslaenge(effektiveKetteWithAEs, ueberstand1, ueberstand2) {
        return echain_shared_quantities_1.Length.mm(effektiveKetteWithAEs.mm + ueberstand1.mm + ueberstand2.mm);
    }
    /**
     * Calculates the missing cable overlap in relation to an RCB configuration
     *
     * Base calculation is: Leitugnslaenge = eff. Kettenlaenge + AEMitnehmer + AEFestpunkt +
     * UeberstandFestpunkt + UeberstandMitnehmer
     *
     * @param effektiveKetteWithAEs
     * @param leitungslaenge
     * @param ueberstand
     */
    static calcMissingUeberstand(effektiveKetteWithAEs, leitungslaenge, ueberstand) {
        return echain_shared_quantities_1.Length.mm(leitungslaenge.mm - effektiveKetteWithAEs.mm - ueberstand.mm);
    }
    /**
     * Checks if a leitung fits into a Configuration if only 1  Ueberstand is given.
     * The other ueberstand will be calculated.
     *
     * If all 3 Length properties are present and fix, use isLeitungLongEnoughForConfiguration
     *
     * If any parameters are null it will return true.
     *
     * @param leitungLength
     * @param ueberstand The known ueberstand of cable
     * @param effektiveKettenLength eff. Kettenlaenge + AEs-Laengen
     */
    static isLeitungAndUeberstandValid(leitungLength, ueberstand, effektiveKettenLength) {
        if (!leitungLength || !ueberstand || !effektiveKettenLength)
            return true;
        const result = this.calcMissingUeberstand(effektiveKettenLength, leitungLength, ueberstand);
        return result && result.mm >= 10;
    }
    /**
     * Checks if a leitung fits into a Configuration.
     *
     * @param leitungslaenge
     * @param ueberstandMitnehmer
     * @param ueberstandFestpunkt
     * @param effektiveKettenLaengeWithAE
     */
    static isLeitungLongEnoughForConfiguration(leitungslaenge, ueberstandMitnehmer, ueberstandFestpunkt, effektiveKettenLaengeWithAE) {
        return leitungslaenge.mm >= effektiveKettenLaengeWithAE.mm + ueberstandFestpunkt.mm + ueberstandMitnehmer.mm;
    }
}
exports.LeitungCalculator = LeitungCalculator;
//# sourceMappingURL=LeitungCalculator.js.map